import { type Grade } from "@core/grades/types";
import { type City } from "@core/shared/types";
import { RegisterForm } from "../components";

export function RegisterPageContent({
  grades,
  cities,
}: {
  grades: Grade[];
  cities: City[];
}) {
  return (
    <>
      <RegisterForm grades={grades} cities={cities} />
    </>
  );
}
